import {call, put, takeEvery} from 'redux-saga/effects'
import Api from "../services/Api";

function* fetchRentalPlanning(action) {
  try {
    const rentalPlanning = yield call(function() {
      return Api.get('/dealer/rental-planning', {date: action.day});
    });
    yield put({type: 'FETCH_RENTAL_PLANNING.SUCCESS', rentalPlanning})
  } catch (error) {
    yield put({type: 'FETCH_RENTAL_PLANNING.FAILURE', error})
  }
}

export function* watchFetchRentalPlanning() {
  yield takeEvery('FETCH_RENTAL_PLANNING.REQUEST', fetchRentalPlanning);
}

function* saveRentalPlanning(action) {
  try {
    const rentalPlanning = yield call(function() {
      return Api.post('/dealer/rental-planning', action.body)
    });

    yield put({type: 'SHOW_NOTIFICATION', notification: {message: 'save.success'}});
    yield put({type: 'SAVE_RENTAL_PLANNING.SUCCESS', rentalPlanning});
  } catch (error) {
    yield put({type: 'SAVE_RENTAL_PLANNING.FAILURE', error});
  }
}

export function* watchSaveRentalPlanning() {
  yield takeEvery('SAVE_RENTAL_PLANNING.REQUEST', saveRentalPlanning)
}
